import React from "react";
import { ArrowDownOutlined } from "@ant-design/icons";
import { Typography, Image, Alert, Tag } from "antd";
import bannerImg from "../../../assets/images/samparkbindu 3.png";
import { Link } from "react-router-dom";

const { Text } = Typography;

const Banner = () => {
  return (
    <div className="banner" id="banner">
      <Alert
        banner
        className="alertUpdate"
        icon={<></>}
        message={
          <React.Fragment>
            <a style={{ color: 'black' }} href="#updates">
              <div className="wrapper">
                <h3 style={{ fontSize: '16px', fontWeight: 700 }}>
                  <Link to="/updates">Updates</Link>
                </h3>
                <Tag
                  color='#e6b31e'
                  style={{
                    fontSize: 'x-small',
                    borderRadius: '5vw',
                    bottom: '0.8vh',
                    position: 'relative'
                  }}
                >
                  New
                </Tag>
                <ul className="dynamic-txts">
                  <li>
                    🎉VikasBandhu Alpha And EngageAll Pilot Stage is Available!
                  </li>
                  <li>
                    Patents filed🎉
                  </li>
                </ul>
              </div>
            </a>
          </React.Fragment>
        }
      >
      </Alert>
      <img src={bannerImg} alt="banner" className="bannerImage" />
      <Typography.Link href="#whatweoffer" className="scroll-title">
        <Typography.Title level={3} className="scroll-title">
          View More <br />
          <ArrowDownOutlined />
        </Typography.Title>
      </Typography.Link>
    </div>
  );
};

export default Banner;
